export default "__VITE_ASSET__BXXPTC2v__"